import {
  TelegramDialogEntity,
  TelegramInboxSettingsEntity,
  TelegramJoinTargetEntity,
  TelegramMessageButtonEntity,
  TelegramMessagesPage,
  assertTelegramMessageId,
  normalizeTelegramInboxSettings,
  normalizeTelegramJoinTarget,
  normalizeTelegramMessageText,
  normalizeTelegramSearchQuery,
  telegramCallbackData,
} from '../../../domain/entities/TelegramMessenger';
import { ITelegramMessengerRepository } from '../../ports/ITelegramMessengerRepository';

export class ListTelegramDialogsUseCase {
  constructor(private repo: ITelegramMessengerRepository) {}
  execute(accountUuid: string) {
    return this.repo.listDialogs(accountUuid);
  }
}

export class ListTelegramDialogMessagesUseCase {
  constructor(private repo: ITelegramMessengerRepository) {}
  execute(accountUuid: string, dialog: TelegramDialogEntity, page?: TelegramMessagesPage) {
    return this.repo.listMessages(accountUuid, dialog, page);
  }
}

export class SendTelegramMessageUseCase {
  constructor(private repo: ITelegramMessengerRepository) {}
  execute(accountUuid: string, dialog: TelegramDialogEntity, text: string) {
    return this.repo.sendMessage(accountUuid, dialog, normalizeTelegramMessageText(text));
  }
}

export class GetTelegramInboxSettingsUseCase {
  constructor(private repo: ITelegramMessengerRepository) {}
  execute(accountUuid: string) {
    return this.repo.getInboxSettings(accountUuid);
  }
}

export class UpdateTelegramInboxSettingsUseCase {
  constructor(private repo: ITelegramMessengerRepository) {}
  execute(accountUuid: string, settings: TelegramInboxSettingsEntity) {
    return this.repo.updateInboxSettings(accountUuid, normalizeTelegramInboxSettings(settings));
  }
}

export class SearchTelegramPeersUseCase {
  constructor(private repo: ITelegramMessengerRepository) {}
  execute(accountUuid: string, query: string) {
    return this.repo.searchPeers(accountUuid, normalizeTelegramSearchQuery(query));
  }
}

export class JoinTelegramPeerUseCase {
  constructor(private repo: ITelegramMessengerRepository) {}
  execute(accountUuid: string, target: TelegramJoinTargetEntity) {
    return this.repo.join(accountUuid, normalizeTelegramJoinTarget(target));
  }
}

export class PressTelegramInlineButtonUseCase {
  constructor(private repo: ITelegramMessengerRepository) {}
  execute(accountUuid: string, dialog: TelegramDialogEntity, messageId: string, button: TelegramMessageButtonEntity) {
    return this.repo.pressButton(accountUuid, dialog, assertTelegramMessageId(messageId), telegramCallbackData(button));
  }
}
